var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.data),function(item){return _c('el-breadcrumb-item',{key:item.path,attrs:{"to":{ path: item.path}}},[_c('span',{staticClass:"content-item"},[_vm._v(_vm._s(item.text))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32505a8f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentHeader.vue
// module id = null
// module chunks = 